import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=1e5a6591&"
import script from "./BaseRadio.vue?vue&type=script&lang=ts&"
export * from "./BaseRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports